module.exports = __webpack_public_path__ + "static/media/truck.72e08b8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/truck.svg
// module id = 254
// module chunks = 0